import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            磁力资源分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大资源分类，精准定位你需要的内容，快速找到对应类型的优质磁力网站。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 max-w-5xl mx-auto">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 mb-1 text-base">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium">
                {cat.count}+ 网站
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}